import { motion } from "framer-motion";

import { useContentAreaRect } from "@/components/VibeChat/widgets/FloatingWidget/hooks/useContentAreaCenter";

const GLOW_INTENSE =
  "inset 0 0 120px 8px rgba(59,130,246,0.3), inset 0 0 40px 4px rgba(59,130,246,0.2), inset 0 0 8px 2px rgba(59,130,246,0.15)";
const GLOW_DIM =
  "inset 0 0 120px 8px rgba(59,130,246,0.12), inset 0 0 40px 4px rgba(59,130,246,0.08), inset 0 0 8px 2px rgba(59,130,246,0.05)";

export const ScreenGlowOverlay = () => {
  const contentArea = useContentAreaRect();

  return (
    <>
      <motion.div
        initial={{ opacity: 0, boxShadow: GLOW_DIM }}
        animate={{
          opacity: 1,
          boxShadow: [GLOW_DIM, GLOW_INTENSE, GLOW_DIM],
        }}
        exit={{ opacity: 0 }}
        transition={{
          opacity: { duration: 0.4, ease: "easeOut" },
          boxShadow: { duration: 3, ease: "easeInOut", repeat: Infinity },
        }}
        className="pointer-events-none fixed bottom-0 top-0 z-40 bg-blue-500/10"
        style={{
          left: contentArea ? `${contentArea.left}px` : 0,
          width: contentArea ? `${contentArea.width}px` : "100%",
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 10, x: "-50%" }}
        animate={{ opacity: 1, y: 0, x: "-50%" }}
        exit={{ opacity: 0, y: 10, x: "-50%" }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="pointer-events-none fixed top-6 z-50 whitespace-nowrap rounded-full bg-blue-600 px-4 py-1.5 text-xs font-medium text-white shadow-lg"
        style={{
          left: contentArea ? `${contentArea.centerX}px` : "50%",
        }}
      >
        Following Agent
      </motion.div>
    </>
  );
};
